import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '@/lib/api';
import { LogIn, AlertCircle } from 'lucide-react';

export default function PortalLogin() {
  const navigate = useNavigate();
  const [pnr, setPnr] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await api.post('/portal/login', { personeelsnummer: pnr.trim(), pin: pin.trim() });
      navigate('/portaal/rooster', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Inloggen mislukt');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-brand-navy via-brand-navy-dark to-slate-900 font-sans p-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-xl bg-brand-amber text-brand-navy text-2xl font-bold shadow-xl">S</div>
          <h1 className="text-2xl font-bold text-white">Portaal</h1>
          <p className="text-sm text-white/60">Medewerker login</p>
        </div>
        <div className="rounded-xl bg-white p-6 shadow-2xl">
          <form onSubmit={handleSubmit} className="space-y-3" data-testid="portal-login-form">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Personeelsnummer</label>
              <input
                type="text"
                inputMode="numeric"
                value={pnr}
                onChange={(e) => setPnr(e.target.value)}
                required
                data-testid="portal-pnr"
                className="w-full rounded-md border border-slate-300 px-3 py-2 text-base"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">PIN (4 cijfers)</label>
              <input
                type="password"
                inputMode="numeric"
                maxLength={4}
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
                required
                data-testid="portal-pin"
                className="w-full rounded-md border border-slate-300 px-3 py-2 text-base tracking-widest text-center"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div className="flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="portal-error">
                <AlertCircle size={14} /> {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="portal-submit"
              className="flex w-full items-center justify-center gap-2 rounded-md bg-brand-navy px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-navy-light disabled:opacity-60"
            >
              <LogIn size={16} /> {submitting ? 'Bezig…' : 'Inloggen'}
            </button>
          </form>
          <p className="mt-5 text-center text-xs text-slate-500">
            Manager?{' '}
            <a href="/login" className="font-medium text-brand-navy hover:underline" data-testid="link-back-login">
              Naar manager-login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
